import { useState, useEffect, useRef } from "react";

export const useTypingEffect = (roles: string[]): string => {
  const [displayText, setDisplayText] = useState("");
  const roleIndexRef = useRef(0);
  const charIndexRef = useRef(0);
  const isDeletingRef = useRef(false);
  const rolesRef = useRef(roles);

  useEffect(() => {
    rolesRef.current = roles;
    roleIndexRef.current = 0;
    charIndexRef.current = 0;
    isDeletingRef.current = false;
    setDisplayText("");
  }, [roles]);

  useEffect(() => {
    let timeout: ReturnType<typeof setTimeout>;

    const type = () => {
      const currentRoles = rolesRef.current;
      if (!currentRoles.length) return;

      const currentRole = currentRoles[roleIndexRef.current % currentRoles.length];

      if (!isDeletingRef.current) {
        charIndexRef.current++;
        setDisplayText(currentRole.substring(0, charIndexRef.current));

        if (charIndexRef.current === currentRole.length) {
          isDeletingRef.current = true;
          timeout = setTimeout(type, 2000);
          return;
        }
        timeout = setTimeout(type, 80);
      } else {
        charIndexRef.current--;
        setDisplayText(currentRole.substring(0, charIndexRef.current));

        if (charIndexRef.current === 0) {
          isDeletingRef.current = false;
          roleIndexRef.current = (roleIndexRef.current + 1) % currentRoles.length;
          timeout = setTimeout(type, 400);
          return;
        }
        timeout = setTimeout(type, 40);
      }
    };

    timeout = setTimeout(type, 500);
    return () => clearTimeout(timeout);
  }, [roles]);

  return displayText;
};
